<template>
    <div v-if="false" class="component-wrap" @keyup.enter='try_auth'>
        <Header-menu :menuVisible="false" />
        <main class="page centered">
            <form class="form">
                <h1 class="form__title">{{ $t("Авторизация") }}</h1>
                <div class="form__row">
                    <baseInput
                        v-model="model_user_mail"
                        type="email"
                        placeholder="E-mail"
                        name="username"
                        :class="{ 'form-group--error': !email_correct && wrong_auth }"
                    />
                </div>
                <div class="form__row">
                    <baseInput
                        v-model="model_user_password"
                        ref="pass"
                        type="password"
                        name="password"
                        :class="{ 'form-group--error': !user_password && wrong_auth }"
                        :placeholder="$t('Пароль')"
                    />
                </div>
                <button-red
                    type="button"
                    class="btn--big"
                    :disabled="disabled"
                    @click.native="try_auth"
                >
                    {{ $t("Войти") }}
                </button-red>
                <div v-if="wrong_auth" class="red--text text-xs-center mt-2">
                    {{ auth_error || $t("Логин или пароль введены неверно") }}
                </div>
                <v-layout class="form__row justify-space-between">
                    <checkbox id="remember_me" @click.native='remember_me($event)'>
                        {{ $t("Запомнить меня") }}
                    </checkbox>
                    <greenLink @click.native="go_to_recover">
                        {{ $t("Забыли пароль?") }}
                    </greenLink>
                </v-layout>

                <v-layout class="form__row">
                    <v-select
                        :value="lang"
                        :items="langs"
                        solo
                        append-icon=""
                        item-text="text"
                        item-value="code"
                        class="nav-select auth-lang"
                        :placeholder="lang ? undefined : lang"
                        attach
                        full-width
                        @change="changeLang($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-layout>
            </form>
        </main>
    </div>
</template>

<script>
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import ButtonRed from '@/components/ui/buttons/button_red.vue';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import baseInput from '@/components/ui/inputs/base/input.vue';
import greenLink from '@/components/ui/links/styled/link_green.vue';
import {mapMutations, mapGetters, mapActions} from 'vuex';
import router from '@/router';

export default {
  name      : 'Auth',
  components: {
    HeaderMenu,
    ButtonRed,
    checkbox,
    baseInput,
    greenLink,
  },
  data() {
    return {
      remember     : false,
      wrong_auth   : false,
      pass_touched : false,
      login_touched: false,
      disabled     : false,
    };
  },
  computed: {
    model_user_mail: {
      get() {
        return this.user_mail;
      },
      set(event) {
        this.login_touched = true;
        this.SET_USER_MAIL(event.target.value);
      },
    },
    model_user_password: {
      get() {
        return this.user_password;
      },
      set(event) {
        this.pass_touched = true;
        this.SET_USER_PASSWORD(event.target.value);
      },
    },
    email_correct() {
      return this.model_user_mail;
    },
    ...mapGetters('autorisation', ['user_password', 'user_mail', 'auth_error']),
    ...mapGetters('profile/general', ['langs', 'lang']),
    ...mapGetters('common', ['loading']),
  },
  mounted() {
    this.SET_USER_ID(null);
  },
  methods: {
    ...mapActions('notifications/Notifications_items', ['get_notifications']),
    ...mapMutations('autorisation', [
      'SET_USER_MAIL',
      'SET_USER_PASSWORD',
      'SET_VALID_FLAG',
      'SET_REMEMBER_ME',
      'SET_USER_ID',
    ]),
    ...mapActions('profile/general', ['update_language']),
    ...mapMutations('common', [
      'LOADING_ON',
      'LOADING_OFF',
    ]),
    remember_me(e) {
      this.SET_REMEMBER_ME(e.target.checked);
    },
    go_to_recover() {
      this.$router.push({name: 'pwd_recover'});
    },
    ...mapActions('autorisation', ['get_token']),
    async try_auth() {
      this.disabled = true;
      const result = await this.get_token();

      if (!result) {
        this.wrong_auth = true;
        this.disabled = false;
        return;
      }

      await this.get_notifications();

      if (window.history.length > 2) {
        router.go(-1);
      } else {
        router.push({name: 'home'});
      }
      this.clearAuthForm();
      this.disabled = false;
    },
    clearAuthForm() {
      this.SET_USER_MAIL('');
      this.SET_USER_PASSWORD('');
      this.SET_REMEMBER_ME(false);
    },
    async changeLang(lang) {
      if (lang) {
        let code = lang.code || lang;
        let langObj = this.langs.filter((item) => item.code == code);

        await this.update_language({lang: langObj[0], serverUpdate: false});
      }
    },
  },
};
</script>
